/**
 * Constantes propias del ER v2.
 *
 * El v2 EXTIENDE las del v1 en vez de modificarlas: `src/pages/ER/constants.js` lo consumen
 * el v1 (12+ call sites en su index.js y su propio CostosFijosTable), y el v1 está CONGELADO.
 * Agregarle un concepto ahí le sumaría una fila al v1 — cambio de render en la vista vieja,
 * exactamente lo que la hermandad v1/v2 evita.
 */
import { camposCostosFijos, nombresCostosFijos } from "../ER/constants";

/**
 * Costos fijos del v2 = los 12 del v1 + Servicios Online.
 *
 * `servicios_online` es una `cuenta_er` que ya se venía clasificando (Google, Nubox y
 * similares) y que NO tenía línea destino en el ER: las facturas quedaban clasificadas,
 * fuera de toda línea y sumando en silencio al total sin clasificar, que además no se
 * renderiza. Costo real que se fugaba del EBITDA.
 *
 * Los dos arrays se indexan EN PARALELO (campo[i] ↔ nombre[i]) y varios consumidores del v2
 * dependen de esa alineación (`getCostoFijoValor` via indexOf, `costosFijosFilas`,
 * `costosFijosPorConcepto`). Agregar un concepto = agregarlo en AMBOS, al final.
 *
 * Pre-2026 la línea vale 0 por construcción: no hay campo homónimo en las tablas manuales,
 * así que `serieManualFija` no encuentra dato ni histórico para promediar y devuelve 0. La
 * paridad diff-cero contra el v1 en 2025 no se toca.
 */
export const camposCostosFijosV2 = [...camposCostosFijos, "servicios_online"];
export const nombresCostosFijosV2 = [...nombresCostosFijos, "Servicios Online"];

/**
 * Nota contable de la línea "Intereses" (debajo del EBITDA) — fundamento normativo de por qué
 * el costo total de factoring (interés + comisión del factor + mora) va completo ahí. Texto
 * único; se muestra como `title` (tooltip nativo, mismo patrón que TipoCambioTable.js) sobre
 * el label de la fila en EBITDAResultadoTable. Ver docs/modulos/er-v2.md y regla 10.277.
 */
export const NOTA_INTERESES_FACTORING =
  "Incluye el costo total del factoring: interés, comisión del factor y mora. El factoring de " +
  "ADIGITAL es con recurso, por lo que el anticipo es financiamiento y no venta de cartera. " +
  "Según NIC 23.5 y 23.6(a) y NIIF 9 B5.4.1, las comisiones de originación integran el costo " +
  "del financiamiento y se presentan junto al interés, debajo del EBITDA. No se identificó " +
  "componente de servicio (administración o cobranza) que corresponda a gasto operativo según " +
  "NIIF 9 B5.4.3. De identificarse en los contratos de los factores, esa porción se " +
  "reclasificaría sobre el EBITDA.";
